import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const services = [
  { icon: "ri-home-smile-line", title: "Daire Temizliği", desc: "Evinizi hijyenik, düzenli ve ferah hale getiren profesyonel daire temizliği hizmeti.", path: "/hizmetlerimiz/daire-temizligi" },
  { icon: "ri-building-line", title: "Bina ve Site Temizliği", desc: "Apartman ve site ortak alanlarında düzenli, planlı ve hijyen odaklı temizlik.", path: "/hizmetlerimiz/bina-ve-site-temizligi" },
  { icon: "ri-building-4-line", title: "Apartman Temizliği", desc: "Merdiven, giriş, lobi ve ortak kullanım alanlarında periyodik temizlik.", path: "/hizmetlerimiz/apartman-temizligi" },
  { icon: "ri-hammer-line", title: "İnşaat Sonrası Temizlik", desc: "Tadilat ve inşaat sonrası detaylı temizlik ile kullanıma hazır alanlar.", path: "/hizmetlerimiz/insaat-sonrasi-temizlik" },
  { icon: "ri-sofa-line", title: "Koltuk Yıkama", desc: "Derinlemesine yıkama ile koltuklarınızı daha hijyenik ve ferah hale getiriyoruz.", path: "/hizmetlerimiz/koltuk-yikama" },
  { icon: "ri-rainbow-line", title: "Halı Yıkama", desc: "Halı yapısına uygun temizlik süreciyle hijyenik ve temiz sonuçlar.", path: "/hizmetlerimiz/hali-yikama" },
  { icon: "ri-t-shirt-line", title: "Kuru Temizleme ve Ütü", desc: "Kıyafetleriniz için özenli kuru temizleme ve düzenli ütü hizmeti.", path: "/hizmetlerimiz/kuru-temizleme-ve-utu" },
  { icon: "ri-bug-line", title: "İlaçlama", desc: "Ev, apartman, site ve iş yerlerinde profesyonel haşere ve böcek ilaçlama.", path: "/hizmetlerimiz/ilaclama" },
  { icon: "ri-briefcase-line", title: "Ofis ve İş Yeri Temizliği", desc: "Çalışan verimliliğini artıran düzenli ofis ve iş yeri temizlik çözümleri.", path: "/hizmetlerimiz/ofis-ve-is-yeri-temizligi" },
  { icon: "ri-shield-user-line", title: "Profesyonel Apartman ve Site Yönetimi", desc: "Güven, şeffaflık ve düzen odaklı profesyonel yönetim hizmeti.", path: "/hizmetlerimiz/profesyonel-apartman-ve-site-yonetimi" },
];

export default function HizmetlerimizPage() {
  return (
    <Layout>
      <section className="relative min-h-[360px] md:min-h-[420px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="/assets/images/hizmetler-hero.jpg"
            alt="Day Temizlik Adana hizmetlerimiz"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(3, 27, 63, 0.85), rgba(3, 27, 63, 0.45))' }}></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="max-w-3xl">
            <span className="inline-block bg-accent-500/90 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              Hizmetlerimiz
            </span>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight mb-4">
              Adana'da ihtiyacınıza uygun temizlik çözümleri
            </h1>
            <p className="text-base md:text-lg text-white leading-relaxed mb-6">
              Day Temizlik Adana, yaşam alanlarınızda hijyen, düzen ve konforu bir araya getiren profesyonel temizlik çözümleri sunar.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {services.map((service) => (
              <Link
                key={service.path}
                to={service.path}
                className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-50 rounded-lg mb-4 group-hover:bg-primary-100 transition-colors">
                  <i className={`${service.icon} w-6 h-6 flex items-center justify-center text-primary-500`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {service.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  Detaylı incele
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
